import Desktop from './Desktop';
import React from 'react';
// other popop screens 
export default function View(props) {

    return <Desktop {...props} />;
}